/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teen_Setting_SavedInputs */

const fr_teen_setting_saved = /** @type {(inputs: Teen_Setting_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglage enregistré`)
};

/**

* @param {Teen_Setting_SavedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teen_setting_saved = /** @type {((inputs?: Teen_Setting_SavedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teen_Setting_SavedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teen_setting_saved(inputs)
});